import { apiGet } from '@/lib/api';

/**
 * Model interface
 */
export interface Model {
  name: string;
  description: string;
}

/**
 * Models API response
 */
export interface ModelsResponse {
  code: number;
  message: string;
  models: Model[];
}

// 缓存模型列表，避免重复请求
let modelsCache: Model[] | null = null;
let modelsFetchPromise: Promise<Model[]> | null = null;

/**
 * 获取可用模型列表（带缓存）
 */
export async function fetchModels(): Promise<Model[]> {
  // 如果已有缓存，直接返回
  if (modelsCache !== null) {
    return modelsCache;
  }

  // 如果正在请求中，返回同一个 Promise，避免并发请求
  if (modelsFetchPromise !== null) {
    return modelsFetchPromise;
  }

  // 创建新的请求 Promise
  modelsFetchPromise = (async () => {
    try {
      const response: any = await apiGet<ModelsResponse>('/api/models');
      const data = response?.data || response || {};

      if (data.code === 200 && data.models) {
        modelsCache = data.models;
        return data.models;
      }

      console.error('Failed to fetch models:', data.message);
      return [];
    } catch (error) {
      console.error('Error fetching models:', error);
      return [];
    } finally {
      // 请求完成后清除 Promise 引用
      modelsFetchPromise = null;
    }
  })();

  return modelsFetchPromise;
}

/**
 * 清除模型缓存（可选，用于强制刷新）
 */
export function clearModelsCache(): void {
  modelsCache = null;
  modelsFetchPromise = null;
}
